import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import { useTranslation } from 'react-i18next';

function RememberMe({
  rememberMe,
  onRememberMeCheckChangeHandler,
}: {
  rememberMe: boolean;
  onRememberMeCheckChangeHandler: () => void;
}) {
  const { t } = useTranslation();
  return (
    <FormGroup sx={{ mb: 3 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={rememberMe}
            onChange={onRememberMeCheckChangeHandler}
          />
        }
        label={t('auth.rememberMe')}
      />
    </FormGroup>
  );
}

export default RememberMe;
